import initialState from "./initialState";
import types from "../actions/actionTypes";
import _ from "lodash";

export default function cultureReducer(state, action) {
    switch (action.type) {
        case types.CULTURE.SET_ALL_LANGUAGES:
            return { ...state, allLanguages: setAllLanguages(action.languages) };
        default:
            return state || initialState.loadInitials().culture;
    }
}

function setAllLanguages(languages) {
    return [...languages.map((language) => _.pick(language, `culture`))];
}
